import React, { useContext, useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import changelog from "../assets/data/changelog";
import GlobalData from "../context/globaldata";

import Modal from "./Modal/Modal";

export default function ChangelogModal() {
  const history = useHistory();
  const appContext = useContext(GlobalData);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isModalShown, setIsModalShown] = useState(false);

  useEffect(() => {
    if (isModalShown) return;

    const authUid = appContext.currentUser?.firebase?.uid;
    const custom = appContext.currentUser?.custom;

    if (!authUid || !custom) return;

    const lastSeen = custom.lastSeenUpdate ?? -1;
    const latest = changelog.length - 1;

    if (lastSeen < latest) {
      appContext.firestore
        .collection("users")
        .doc(authUid)
        .update({ lastSeenUpdate: latest })
        .then(() => {
          setIsModalVisible(true);
          setIsModalShown(true);
        })
        .catch((err: Error) => console.error("Update failed:", err));
    }
  }, [
    appContext.currentUser?.custom,
    appContext.currentUser?.firebase?.uid,
    isModalShown,
  ]);

  if (changelog.length === 0) {
    return null;
  }

  return (
    <Modal
      title="What's new"
      headerNoPaddingBottom={true}
      visible={isModalVisible}
      cancelAction={() => {
        history.push("/changelog");
        setIsModalVisible(false);
      }}
      closeAction={() => {
        setIsModalVisible(false);
      }}
      cancelLabel="View previous updates"
    >
      <p className="modal__subtitle">{changelog[0].date}</p>
      {changelog[0].summary}
    </Modal>
  );
}
